// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import DataTable from 'vue-bulma-datatable'

Vue.config.productionTip = false

Vue.component('data-table', DataTable)

// Import the external CSS globally
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'http://at.alicdn.com/t/font_1389589_lbfmw9spx9.css'
document.head.appendChild(link)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js